export default __webpack_public_path__ + "static/media/icon--financial-model.182c0f60.svg";